'use client';

import * as Tooltip from '@radix-ui/react-tooltip';
import { MouseEvent, useState } from 'react';

import { useTranslation } from '@lichtblick/i18next';
import { Link } from '@lichtblick/icons';
import { Colors, TextVariants } from '@lichtblick/theme';

import { TooltipContent } from './CopyButton.styles';

import { IconButton } from '../IconButton';
import { Text } from '../Text';

export type CopyButtonProps = {
  copyText: string;
};

const beforeClickLabel = 'ui.copyButton.beforeClick';
const afterClickLabel = 'ui.copyButton.afterClick';

type labels = typeof beforeClickLabel | typeof afterClickLabel;

export const CopyButton = ({ copyText }: CopyButtonProps) => {
  const { t } = useTranslation('common');
  const [label, setLabel] = useState<labels>(beforeClickLabel);

  const copyClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    navigator.clipboard.writeText(copyText);

    setLabel(afterClickLabel);
  };

  return (
    <Tooltip.Provider delayDuration={0}>
      <Tooltip.Root>
        <Tooltip.Trigger
          asChild
          onClick={(e) => e.preventDefault()}
          onMouseLeave={() =>
            setTimeout(() => {
              setLabel(beforeClickLabel);
            }, 10)
          }
        >
          <IconButton icon={<Link />} onClick={copyClick}></IconButton>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <TooltipContent asChild data-testid="copy-button-popover" onPointerDownOutside={(e) => e.preventDefault()}>
            <Text $variant={TextVariants.button.s} color={Colors.white}>
              {t(label)}
            </Text>
          </TooltipContent>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
